import { useEffect, useState } from "react";
import CategoriesList from "./CategoriesList";
import CategoryDetail from "./CategoryDetail";
import {
  useGetAdminCategoriesQuery,
  useGetCategoriesQuery,
  useGetMainCategoriesQuery,
} from "../../../api/admin/categoriesApi";

const CategoriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState();
  const [isCategoryChanged, setIsCategoryChanged] = useState(false);
  const [macroCategories, setMacroCategories] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [showPermanentCategories, setShowPermanentCategories] = useState(false);
  const [categoryInputValue, setCategoryInputValue] = useState("");

  const { data: categoriesList } = useGetCategoriesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  }); //chiamata per la lista di categorie custom (x LLM)

  const { data: mainCategoriesList } = useGetMainCategoriesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  }); //chiamata per la lista di macro categorie

  const { data: allCategories } = useGetAdminCategoriesQuery(); //solita chiamata per ottenere le categorie, usata per popolare le categorie fisse

  useEffect(() => {
    if (allCategories?.Data) {
      const expCat = allCategories.Data.flatMap(
        (e) => e.expenseCategories
      ).filter((e) => !["Residuale", "DynamicForm"].includes(e.categoryType));
      setExpenseCategories(expCat); //dentro expCat ci sono solo quelle fisse (CU, Doc identità, spese sanitarie, esito pratiche, F24)
    }
  }, [allCategories?.Data]);

  useEffect(() => {
    if (mainCategoriesList?.Data) {
      setMacroCategories(
        mainCategoriesList?.Data?.items?.map(({ name, id }) => ({
          label: name,
          value: id,
        }))
      );
    }
  }, [mainCategoriesList?.Data]);

  return (
    <div className="w-full flex flex-col xl:flex-row gap-8">
      <CategoriesList
        macroCategories={macroCategories}
        categoriesList={(showPermanentCategories
          ? expenseCategories
          : categoriesList?.Data?.items
        )?.filter((e) =>
          e.name.toLowerCase().includes(categoryInputValue.toLowerCase())
        )}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        isCategoryChanged={isCategoryChanged}
        setIsCategoryChanged={setIsCategoryChanged}
        showPermanentCategories={showPermanentCategories}
        setShowPermanentCategories={setShowPermanentCategories}
        categoryInputValue={categoryInputValue}
        setCategoryInputValue={setCategoryInputValue}
      />
      <CategoryDetail
        macroCategories={macroCategories}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        isCategoryChanged={isCategoryChanged}
        setIsCategoryChanged={setIsCategoryChanged}
      />
    </div>
  );
};

export default CategoriesPage;
